import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstance } from '../../Apis/Axios';
import { t } from 'i18next';
import { toast } from 'react-toastify';
import { postSessionStorageLoader } from '../../Apis/functions';
import { ADVANCED_SEARCH_SERVICE } from '../EndPoints';

// Get Attributes Filter /advanced-search-service/get-all/by-module-id/{moduleId} search-module searching-controller
export const GetAttributesFilter = createAsyncThunk(
    'search/getAttributesFilter',
    async (moduleId) => {
        const result = await apiInstance
            .get(`${ADVANCED_SEARCH_SERVICE.getAttributesFilter}${moduleId}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Condition Filter /advanced-search-service/get-all/by-module-id/{moduleId} search-module searching-controller
export const GetConditionFilter = createAsyncThunk(
    'search/getConditionFilter',
    async (typeAttribute) => {
        const result = await apiInstance
            .get(`${ADVANCED_SEARCH_SERVICE.getConditionFilter}${typeAttribute}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Values By Option and Field /advanced-search-service/{option}/{field}/values-to-filter search-module searching-controller
export const GetValuesByOptionAndField = createAsyncThunk(
    'search/getValuesByOptionAndField',
    async ({ option, field }) => {
        const result = await apiInstance
            .get(ADVANCED_SEARCH_SERVICE.getValuesByOptionAndField(option, field))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Values By Option and Field /advanced-search-service/{option}/{field}/values-to-filter search-module searching-controller
export const GetValuesByOptionFieldAndUserId = createAsyncThunk(
    'search/getValuesByOptionFieldAndUserId',
    async ({ option, field, userId }) => {
        const result = await apiInstance
            .get(ADVANCED_SEARCH_SERVICE.getValuesByOptionFieldAndUserId(option, field, userId))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Search By Filters /advanced-search-service/{option} search-module searching-controller
export const SearchByFilters = createAsyncThunk(
    'search/searchByFilters',
    async ({ option, body, showSuccessMsg=true }) => {
        postSessionStorageLoader(true);
        let result = await apiInstance
            .post(`${ADVANCED_SEARCH_SERVICE.searchByFilters}${option}`, body)
            .then(function (response) {
                if (showSuccessMsg && body?.rootGroup) {
                    toast.success(t('search_completed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Search By Filters /advanced-search-service/{option} search-module searching-controller
export const SearchByFiltersCustom = createAsyncThunk(
    'search/searchByFiltersCustom',
    async ({ option, body }) => {
        postSessionStorageLoader(true);
        let result = await apiInstance
            .post(ADVANCED_SEARCH_SERVICE.searchByFiltersCustom(option), body)
            .then(function (response) {
                if (body?.rootGroup) {
                    toast.success(t('search_completed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// List all the posible models in the dropdown (done)
export const GetListSearchModels = createAsyncThunk(
    'search/getListSearchModels',
    async () => {
        const result = await apiInstance
            .get(ADVANCED_SEARCH_SERVICE.getListSearchModels)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

// Get Values To FilterCrudLogByField
export const GetValuesToFilterLogByField = createAsyncThunk(
    'search/getValuesToFilterLogByField',
    async ({ model, field }) => {
        const result = await apiInstance
            .get(ADVANCED_SEARCH_SERVICE.getValuesToFilterLogByField(model, field))
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Search CrudLog by Model /advanced-search-service/{model}/crud-log search-module searching-controller
export const SearchCrudLogByModel = createAsyncThunk(
    'search/searchCrudLogByModel',
    async ({ model, body }) => {
        postSessionStorageLoader(true);
        let result = await apiInstance
            .post(ADVANCED_SEARCH_SERVICE.searchCrudLogByModel(model), body)
            .then(function (response) {
                if (body.searchCriteriaList.length > 0) {
                    toast.success(t('search_completed_successfully'));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

// Get Search By Filters /advanced-search-service/simple search-module searching-controller
export const SimpleSearch = createAsyncThunk('search/SimpleSearch', async ({ body }, { dispatch, getState }) => {
    let result = await apiInstance
        .post(ADVANCED_SEARCH_SERVICE.simpleSearch, body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
// Get Search By Filters /advanced-search-service/simple/user search-module searching-controller

export const SimpleSearchWithId = createAsyncThunk(
    'search/SimpleSearchWithId',
    async ({ body }) => {
        let result = await apiInstance
            .post(ADVANCED_SEARCH_SERVICE.simpleSearchWithId, body)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;
        return { data, status };
    },
);

export const SearchUserZone = createAsyncThunk('search/searchUserZone', async ({ body }) => {
    let result = await apiInstance
        .post(ADVANCED_SEARCH_SERVICE.searchUserZone(body?.model), body)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;
    return { data, status };
});
